import { Route, Routes, BrowserRouter } from "react-router-dom";
import React from "react";
import PreScreen from "../app/PreScreen";
import Home from "../app/home/page";
import About from "../app/about/page";
import Blog from "../app/blog/page";
import CircularDesign from "../app/circular-design/page";
import DesignShop from "../app/design-shop/page";
import CircularDesignID from "../app/circular-design/[id]/page";
import Knowledge from "../app/knowledge/page";
import KnowledgeID from "../app/knowledge/[id]/page";
import Museum from "../app/museum/page";
import TextileLab from "../app/textile-lab/page";
import BlogID from "../app/blog/[id]/page";
import AdminLogin from "../app/admin/page";
import AdminHome from "../app/admin/home/page";
import AdminPost from "../app/admin/post/page";
import AdminPostID from "../app/admin/post/[id]/page";
import AdminPostAdd from "../app/admin/post/add/page";
import AdminPostKnowledge from "../app/admin/post/knowledge/page";
import AdminProducts from "../app/admin/products/page";
import AdminProductsID from "../app/admin/products/[id]/page";
import AdminProductsAdd from "../app/admin/products/add/page";
import NoPage from "../app/NoPage";
// import AdminProductsVerifyID from "../app/admin/products/verify/[id]/page";
// import Blog from "../app/blog/page";
// import About from "../app/about/page";

export default function MainRouter() {
  return (
    <BrowserRouter>
      <Routes>
        <Route exact path="/" element={<PreScreen />}>
          {/* <Route path="blog" element={<Blog />} />
          <Route path="about" element={<About />} /> */}
        </Route>
        <Route path="/home" element={<Home />} />
        <Route path="/about" element={<About />} />
        <Route path="/blog" element={<Blog />} />
        <Route path="/blog/:id" element={<BlogID />} />
        <Route path="/circular-design" element={<CircularDesign />} />
        <Route path="/circular-design/:id" element={<CircularDesignID />} />
        <Route path="/design-shop" element={<DesignShop />} />
        <Route path="/knowledge" element={<Knowledge />} />
        <Route path="/knowledge/:id" element={<KnowledgeID />} />
        <Route path="/museum" element={<Museum />} />
        <Route path="/textile-lab" element={<TextileLab />} />

        <Route path="/admin/" element={<AdminLogin />}/>
        <Route path="/admin/home" element={<AdminHome />} />
        <Route path="/admin/post" element={<AdminPost />} />
        <Route path="/admin/post/:id" element={<AdminPostID />} />
        <Route path="/admin/post/add" element={<AdminPostAdd />} />
        <Route path="/admin/post/knowledge" element={<AdminPostKnowledge />} />
        <Route path="/admin/products" element={<AdminProducts />} />
        <Route path="/admin/products/:id" element={<AdminProductsID />} />
        <Route path="/admin/products/add" element={<AdminProductsAdd />} />
        {/* <Route path="/admin/products/verify/:id" element={<AdminProductsVerifyID />} /> */}
        <Route path="*" element={<NoPage />} />

      </Routes>
    </BrowserRouter>
  );
}
